<div class="flex justify-end">
  <button
    mat-flat-button
    color="primary"
    class="my-16 mx-8"
    (click)="printReportOfExamination()"
  >
    Print
  </button>
  <button
    mat-flat-button
    color="primary"
    class="my-16 mx-8"
    (click)="emailReportOfExamination()"
  >
    Email
  </button>
  <button
    mat-flat-button
    color="primary"
    class="my-16 mx-8"
    (click)="openPDF()"
  >
    Download
  </button>
</div>

<!-- Preview -->
<div class="flex flex-col mb-6 p-16 border" id="print-section">
  <div>
    <img class="w-full" src="../../../assets/dlm-images/dlm/rot-header.png" />
  </div>
  <div
    class="flex flex-col justify-center items-center my-16 w-full"
  >
    <h2 class="">Report Of Thorough Examination</h2>
    <h2 class="">
      This report meets the requirements of schedule 1 of regulation 10 of LOLER
      1998
    </h2>
  </div>
  <div class="flex flex-col justify-center my-16 px-8 w-full">
    <div class="flex flex-row justify-between">
      <div class="flex flex-row">
        <p class="mr-4">Company Name & Address:</p>
        <p class="">
          Dynamic Load Monitoring (UK) Ltd, DLM House, Nursling, Southampton
        </p>
      </div>
      <div class="flex flex-row">
        <p class="mr-4">Phone:</p>
        <p class="">02380 741700</p>
      </div>
    </div>

    <div class="flex flex-row justify-between">
      <div class="flex flex-row">
        <p class="mr-4">Report No:</p>
        <p class="">{{ model?.form10a?.form10aId }}</p>
      </div>
      <div class="flex flex-row">
        <p class="mr-4">Customer No:</p>
        <p class="">{{ model?.form10a?.form10aId }}</p>
      </div>
      <div class="flex flex-row">
        <p class="mr-4">Date of Report:</p>
        <p class="">{{ getTodaysDate() | date: "dd/MM/yyyy" }}</p>
      </div>
      <div class="flex flex-row">
        <p class="mr-4">Color Code (if required):</p>
        <p class="">N/A</p>
      </div>
    </div>
  </div>
  <div
    class="flex flex-col general-details-container justify-center items-center mt-16 w-full"
  >
    <div class="flex flex-row items-stretch w-full">
      <div class="cell flex flex-col w-40">
        <small class="mr-4">Name & Address of the employer for whom the examination was made:</small>
        <small class="">{{ model?.loadcell?.customerName }}</small>
      </div>
      <div class="cell flex flex-col w-40">
        <small class="mr-4">Address of the premises at which the examination was made:</small>
        <small class="">SO18 1DH</small>
        <small class="">Southampton</small>
      </div>
      <div class="cell flex flex-col w-20">
        <small class="mr-4">Status: </small>
        <small>
          ND - No Defect<br/>
          SDR - See Defect Report<br/>
          NF - Not Found
        </small>
      </div>
    </div>

    <div class="flex flex-row items-stretch w-full">
      <div class="cell flex justify-center text-center w-10">
        <small class=" mr-4"><strong>Identification Number</strong></small>
      </div>
      <div class="cell flex justify-center text-center w-10">
        <small class=" mr-4"><strong>Description</strong></small>
      </div>
      <div class="cell flex justify-center text-center w-10">
        <small class=" mr-4"><strong>WLL<br/>or<br/>SWL</strong></small>
      </div>
      <div class="cell flex justify-center text-center w-10">
        <small class=" mr-4"><strong>Date of Last Thorough Examination</strong></small>
      </div>
      <div class="cell flex justify-center text-center w-10">
        <small class=" mr-4"><strong>Date of this Thorough Examination</strong></small>
      </div>
      <div class="cell flex justify-center text-center w-10">
        <small class=" mr-4"><strong>Latest date of the next thorough examination</strong></small>
      </div>
      <div class="cell flex justify-center text-center w-10">
        <small class=" mr-4"><strong>Reason for Examination<br/>(See Below)</strong></small>
      </div>
      <div class="cell flex justify-center text-center w-10">
        <small class=" mr-4"><strong>Details of any test</strong></small>
      </div>
      <div class="cell flex justify-center text-center w-10">
        <small class=" mr-4"><strong>Status<br/>(See above)</strong></small>
      </div>
      <div class="cell flex justify-center text-center w-10">
        <small class=" mr-4"><strong>Safe to Use<br/>Yes or No</strong></small>
      </div>
    </div>

    <ng-container *ngFor="let item of model?.form10a?.roTEItems">
      <div class="flex flex-row items-stretch w-full">
        <div class="cell flex justify-center text-center w-10">
          <small class="mr-4">RTE-{{ item.roTEItemId }}</small>
        </div>
        <div class="cell flex justify-center text-center w-10">
          <small class="mr-4">{{ item.roTEDescription }}</small>
        </div>
        <div class="cell flex justify-center text-center w-10">
          <small class="mr-4">{{ calibration?.swl }}</small>
        </div>
        <div class="cell flex justify-center text-center w-10">
          <small class="mr-4">N/A</small>
        </div>
        <div class="cell flex justify-center text-center w-10">
          <small class="mr-4">{{calibration?.date | date: "dd/MM/yyyy"}}</small>
        </div>
        <div class="cell flex justify-center text-center w-10">
          <small class="mr-4">{{getNextExaminationDate() | date: "dd/MM/yyyy"}}</small>
        </div>
        <div class="cell flex justify-center text-center w-10">
          <small class="mr-4">{{getReasonCode(item.reasonForExamination)}}</small>
        </div>
        <div class="cell flex justify-center text-center w-10">
          <small class="mr-4">{{ item.detailsOfAnyTest }}</small>
        </div>
        <div class="cell flex justify-center text-center w-10">
          <small class="mr-4">{{ getStatusCode(item.status) }}</small>
        </div>
        <div class="cell flex justify-center text-center w-10">
          <small class="mr-4">{{ item.safeToUse ? "yes" : "no" }}</small>
        </div>
      </div>
    </ng-container>

    <div class="flex flex-row items-stretch w-full">
      <div class="cell flex w-20">
        <small class=" mr-4"><strong>Reason for Examination</strong></small>
      </div>
      <div class="cell flex flex-row w-20">
        <small class="mr-4">Installation:</small>
        <small class=""><strong>A</strong></small>
      </div>
      <div class="cell flex flex-row w-20">
        <small class="mr-4">6 Monthly:</small>
        <small class=""><strong>B</strong></small>
      </div>
      <div class="cell flex flex-row w-20">
        <small class="mr-4">12 Monthly:</small>
        <small class=""><strong>C</strong></small>
      </div>
      <div class="cell flex flex-row w-20">
        <small class="mr-4">Written Scheme:</small>
        <small class=""><strong>D</strong></small>
      </div>
      <div class="cell flex flex-row w-20">
        <small class="mr-4">Exceptional Circumstances:</small>
        <small class=""><strong>E</strong></small>
      </div>
    </div>

    <div class="flex flex-row items-stretch w-full">
      <div class="cell flex flex-col w-50">
        <small class="mr-4"
          >Name & qualifications of the person making this report:</small
        >
        <small class="flex items-center  mr-4 h-full">{{
          model?.form10a?.nameAndQualificationsOfThePerson
        }}</small>
      </div>
      <div class="cell flex flex-col w-50">
        <small class="mr-4"
          >Name of the person authenticating this report:</small
        >
        <small class="flex items-center  mr-4 h-full">{{
          model?.form10a?.nameOfThePersonAuthenticating
        }}</small>
        <div class="flex flex-row">
          <small class="flex items-end mr-4">Signature:</small>
          <img class="h-[60px] w-auto" src="{{ model?.form10a?.signature }}" />
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Print stuff -->
<div id="print-header" style="display: none;">
  <div class="fixed-width p-16">
    <img class="w-full" src="../../../assets/dlm-images/dlm/rot-header.png" />
  </div>
</div>

<div id="print-signature" style="display: none;">
  <div>
    <img class="h-[160px] w-auto" src="{{ model?.form10a?.signature }}" />
  </div>
</div>
